import styled from 'styled-components/native';
import ButtonIcon from '~/components/ButtonIcon';

export const SettingsButtonIconIcon = styled(ButtonIcon).attrs(({ theme }) => ({
  styledName: 'settings',
  color: theme.color.base.c7,
  size: 24,
}))``;
